// prettier-ignore
export const TARGET_URLS:{[key: string]: string} = {
  'Charlottenburg-Wilmersdorf': 'Charlottenburg+%28Berlin%29',
  'Friedrichshain-Kreuzberg': 'Friedrichshain+%28Berlin%29',
  'Lichtenberg':  'Lichtenberg+%28Berlin%29',
  'Mitte': 'Mitte+%28Berlin%29',
  'Neukölln': 'Neuk%C3%B6lln+%28Berlin%29',
  'Marzahn-Hellersdorf': 'Marzahn+%28Berlin%29',
  'Pankow': 'Pankow+%28Berlin%29',
  'Reinickendorf': 'Reinickendorf+%28Berlin%29',
  'Steglitz-Zehlendorf': 'Steglitz+%28Berlin%29',
  'Spandau': 'Spandau+%28Berlin%29',
  'Tempelhof-Schöneberg': 'Templelhof+%28Berlin%29',
  'Treptow-Köpenick': 'Treptow+%28Berlin%29',
}
